class Repository {
    constructor(endpoint) {
        this.endpoint = window.akita.urls.api + "/v1/activities";
    }

    remove(id, request) {
        return axios.delete(this.endpoint + "/" + id, request);
    }

    index(request) {
        return axios.get(this.endpoint, request);
    }

    async indexAll(params, options) {
        var config = Object.assign(
            {},
            { next: "data.links.next", pageSize: 100 },
            options
        );
        let response;
        let finished = false;
        let page = 1;
        let data = [];
        let request = {
            params: params,
        };
        while (!finished) {
            request.params.page = page;
            request.params.per_page = config.pageSize;
            response = await axios.get(this.endpoint, request);

            data.push(...response.data.data);
            finished = _.get(response, config.next) ? false : true;
            ++page;
        }
        return data;
    }

    show(id, request) {
        return axios.get(this.endpoint + "/" + id, request);
    }

    store(payload, request) {
        return axios.post(this.endpoint, payload, request);
    }

    update(id, payload, request) {
        return axios.put(this.endpoint + "/" + id, payload, request);
    }

    attachments(activityId) {
        return new (require("@/js/repositories/activity-attachments.js"))(
            window.akita.urls.api +
                "/v1/activities/" +
                activityId +
                "/attachments"
        );
    }

    followers(activityId) {
        return new (require("@/js/repositories/base.js"))(
            window.akita.urls.api +
                "/v1/activities/" +
                activityId +
                "/followers"
        );
    }
}

module.exports = Repository;
